import { PortalDesignComponent } from './portal-design/portal-design.component';
import { PortalSendingMailComponent } from './portal-identity/portal-identity-page/portal-sending-mail/portal-sending-mail.component';
import { PortalMarketingOverviewComponent } from './portal-marketing/portal-marketing-overview/portal-marketing-overview.component';
import { PortalSubscribersComponent } from './portal-marketing/portal-subscribers/portal-subscribers.component';
import { PortalMarketingPageComponent } from './portal-marketing/portal-marketing-page/portal-marketing-page.component';

import { PortalFunnelsComponent } from './portal-content/portal-funnels/portal-funnels.component';

import { PortalContentPageComponent } from './portal-content/portal-content-page/portal-content-page.component';
import { WebsitePagesComponent } from './portal-content/portal-pages/portal-pages.component';
import { IntegratePortalPaymentsComponent } from './portal-payment/integrate/integrate.component';
import { ViewPortalPaymentsComponent } from './portal-payment/view/view.component';
import { ListPortalPaymentsComponent } from './portal-payment/list/list.component';
import { PortalPaymentComponent } from './portal-payment/portal-payment.component';

import { PortalDomainsComponent } from './portal-domains/portal-domains.component';

import { PortalOverviewComponent } from './portal-overview/portal-overview.component';
import { PortalViewMainPageComponent } from './portal-view-page/portal-view-page.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PortalIdentityComponent } from './portal-identity/portal-identity.component';
import { BasicInformationComponent } from './portal-identity/portal-identity-page/basic-information/basic-information.component';
import { PortalSettingsComponent } from './portal-settings/portal-settings.component';
import { PortalNavigationComponent } from './portal-settings/portal-navigation/portal-navigation.component';
import { SiteIdentityComponent } from './site-identity/site-identity.component';

const routes: Routes = [
  {
    path: '',
    component: PortalViewMainPageComponent,
    data: {
      uiMode: 'sidebar-minimized',
    },
    children: [
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full',
      },
      {
        path: 'overview',
        component: PortalOverviewComponent,
      },
      {
        path: 'site-identity',
        component: SiteIdentityComponent,
      },

      {
        path: 'branding',
        component: PortalDesignComponent,
      },
      {
        path: 'identity',
        redirectTo: 'site-identity',
        pathMatch: 'full',
      },

      {
        path: 'content',
        component: PortalContentPageComponent,

        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'pages',
          },
          {
            path: 'pages',
            component: WebsitePagesComponent,
          },
          {
            path: 'funnels',
            component: PortalFunnelsComponent,
          },
        ],
      },
      {
        path: 'marketing',
        component: PortalMarketingPageComponent,

        children: [
          {
            path: '',
            redirectTo: 'overview',
            pathMatch: 'full',
          },
          {
            path: 'overview',
            component: PortalMarketingOverviewComponent,
          },
          {
            path: 'subscribers',
            component: PortalSubscribersComponent,
          },
        ],
      },
      {
        path: 'settings',
        component: PortalSettingsComponent,
        children: [
          {
            path: '',
            redirectTo: 'domains',
            pathMatch: 'full',
          },
          {
            path: 'navigation',
            component: PortalNavigationComponent,
          },
          {
            path: 'payments',
            component: PortalPaymentComponent,

            children: [
              {
                path: '',
                component: ListPortalPaymentsComponent,
              },
              {
                path: ':slug/view',
                component: ViewPortalPaymentsComponent,
              },
              {
                path: ':slug/integrate',
                component: IntegratePortalPaymentsComponent,
              },
            ],
          },
          {
            path: 'domains',
            component: PortalDomainsComponent,
          },
          {
            path: 'mailing',
            component: PortalSendingMailComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PortalViewRoutingModule {}
